<template>
<v-dialog
    v-model="dialog"
    max-width="920"
>
    <v-card>
        <v-card-title>Review customer information</v-card-title>

        <v-card-text
            v-if="profile != null"
        >
           <v-text-field
                label="Customer Name (as enteted by customer)"
                readonly
                :value="profile.customer_entered_name"
                disabled
           />

           <v-row>
                <v-col>
                    <v-text-field
                        label="First Name"
                        v-model="profile.first_name"
                    />
                </v-col>
                <v-col>
                     <v-text-field
                        label="Last Name"
                        v-model="profile.last_name"
                    />
                </v-col>
           </v-row>

           <v-text-field
                label="Phone Number"
                v-model="profile.endpoint"
            />

           <v-text-field
                label="Email Address"
                v-model="profile.email"
            />

             <v-alert 
                v-model="show_alert" 
                type="error" 
                dismissible
                color="primary"
              >
                {{ alert_text }}
              </v-alert>

        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onCancel"
            >
            Cancel
            </v-btn>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
            >
            Create customer in Commerce7
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>
const _ = require('lodash');
const Validation = require('@/js/validate.js');
export default {

    data() {
        return {
            dialog: false,
            profile: null,
            show_alert: false,
            alert_text: null,
        }
    },

    methods: {

        showDialog(profile)
        {
            this.show_alert = false;
            this.profile = _.cloneDeep(profile);
            this.profile.endpoint = this.$rc.pretty(this.profile.endpoint,'endpoint_no_parens'); 
            this.dialog = true;
        },

        onOk()
        {
            // Validate...

            {
                if ( this.$rc.isBlank(this.profile.first_name) )
                {
                    this.show_alert = true;
                    this.alert_text = 'A first name is required';
                    return;
                }

                if ( this.$rc.isBlank(this.profile.last_name) )
                {
                    this.show_alert = true;
                    this.alert_text = 'A last name is required';
                    return;
                }

                if ( this.$rc.isBlank(this.profile.email) || !Validation.isEmailAddress(this.profile.email) )
                {
                    this.show_alert = true;
                    this.alert_text = 'An email address is required';
                    return;
                }

                if ( this.$rc.isBlank(this.profile.endpoint) || !Validation.isUSPhoneNumber(this.profile.endpoint) )
                {
                    this.show_alert = true;
                    this.alert_text = 'A valid phone number is required';
                    return;
                }
            }

            this.$emit('ok', this.profile);
            this.dialog = false;
        },

        onCancel()
        {
            this.dialog = false;
        },

    },
}
</script>

<style lang="scss" scoped>
</style>